import { render, staticRenderFns } from "./AutomatedComponent.vue?vue&type=template&id=e97425ce&"
import script from "./AutomatedComponent.vue?vue&type=script&lang=js&"
export * from "./AutomatedComponent.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports